/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment, object-curly-newline */
import React, { ChangeEvent, useState } from 'react';
import {
  InputLabel,
  TextField,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { MdOutlineVisibility, MdOutlineVisibilityOff } from 'react-icons/md';
import { CommonElementProps } from '../types';
import ElementUtils from '../utils';

export interface PasswordProps extends CommonElementProps<string> {
  label?: string;
  value?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
}

function Password(props: PasswordProps) {
  const { label, value, disabled, error, onChange } = props;

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
  };

  const handleValueChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <div className="flex flex-col relative justify-center items-start">
      {label && (
        <InputLabel className="font-bold text-[#28364C]" error={!!error}>
          {label}
        </InputLabel>
      )}
      <TextField
        id="outlined-password"
        sx={{
          '& fieldset': { border: 'none' },
        }}
        color="primary"
        type={showPassword ? 'text' : 'password'}
        value={value}
        defaultValue={value}
        variant="outlined"
        disabled={disabled}
        fullWidth
        onChange={handleValueChange}
        error={Boolean(error)}
        InputProps={{
          endAdornment: (
            <div className="h-[2.5rem] overflow-clip min-w-[3.25rem] flex justify-center items-center rounded-[0.625rem]">
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? (
                    <MdOutlineVisibilityOff />
                  ) : (
                    <MdOutlineVisibility />
                  )}
                </IconButton>
              </InputAdornment>
            </div>
          ),
          classes: {
            root: 'bg-white custom-shadow rouded-md mt-1',
            error: 'outline outline-[1px] outline-error',
          },
        }}
      />
      {error && (
        <div className="absolute -bottom-5 text-error text-xs">
          {ElementUtils.renderError(error)}
        </div>
      )}
    </div>
  );
}

Password.defaultProps = {
  label: '',
  value: '',
  disabled: false,
  onChange: () => {},
};

export default Password;
